module.exports = __webpack_public_path__ + "static/media/kid_avatar_03.640a496d.png";